var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    [
      _c(
        "span",
        { attrs: { slot: "label" }, slot: "label" },
        [
          _vm._v(_vm._s(_vm.i18nt("designer.setting.fileTypes")) + "\n    "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content: _vm.i18nt("designer.setting.fileTypesHelp"),
              },
            },
            [_c("i", { staticClass: "el-icon-info" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            multiple: "",
            "allow-create": "",
            filterable: "",
            "default-first-option": "",
          },
          model: {
            value: _vm.optionModel.fileTypes,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "fileTypes", $$v)
            },
            expression: "optionModel.fileTypes",
          },
        },
        _vm._l(_vm.uploadPictureTypes, function (ft, ftIdx) {
          return _c("el-option", {
            key: ftIdx,
            attrs: { label: ft.label, value: ft.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }